import { useState } from "react";

export default function AdminAIPredictionCenter() {

    const [prediction] = useState({
        shipmentRisk: 6,
        delayProbability: 14,
        iotFailure: 3,
        securityThreat: 1,
        aiConfidence: 98,
    });

    return (
        <div style={{ padding: 20 }}>

            <h2>AI Prediction Center</h2>

            <p>
                Artificial Intelligence prediction dashboard.
            </p>

            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit,minmax(250px,1fr))",
                    gap: 20,
                }}
            >

                <Card
                    title="Shipment Risk"
                    value={`${prediction.shipmentRisk}%`}
                    color="#E53935"
                />

                <Card
                    title="Delay Probability"
                    value={`${prediction.delayProbability}%`}
                    color="#FB8C00"
                />

                <Card
                    title="IoT Failure"
                    value={`${prediction.iotFailure}%`}
                    color="#5E35B1"
                />

                <Card
                    title="Security Threat"
                    value={`${prediction.securityThreat}%`}
                    color="#1E88E5"
                />

                <Card
                    title="AI Confidence"
                    value={`${prediction.aiConfidence}%`}
                    color="#43A047"
                />

            </div>

        </div>
    );
}

function Card({ title, value, color }) {
    return (
        <div
            style={{
                background: "white",
                borderLeft: `8px solid ${color}`,
                borderRadius: 12,
                padding: 20,
                boxShadow: "0 3px 12px rgba(0,0,0,.1)",
            }}
        >
            <div style={{ color: "#666" }}>
                {title}
            </div>

            <div
                style={{
                    fontSize: 36,
                    fontWeight: "bold",
                    marginTop: 10,
                }}
            >
                {value}
            </div>
        </div>
    );
}